module.exports = __webpack_public_path__ + "static/app-store-0f3514a45d51f95167e5fe8b6a03bb60.svg";